import { request } from "./request";

export function login(data) {
  return request("/auth/login", {
    method: "POST",
    body: data,
  });
}

export function register(data) {
  return request("/auth/register", {
    method: "POST",
    body: data,
  });
}

